"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FResponseBar = void 0;
const react_1 = __importDefault(require("react"));
const f_icon_close_svg_1 = require("../assets/images/f-icons/f-icon-close.svg");
const FResponseBar = ({ className = "", variant = "", title = "", show = false, onClose = () => { }, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, show && (react_1.default.createElement("div", { className: `f-response-bar f-variant f-variant-${variant} ${className}` },
        react_1.default.createElement("span", null, title),
        " ",
        react_1.default.createElement(f_icon_close_svg_1.ReactComponent, { className: "icon-close", onClick: () => onClose() })))));
};
exports.FResponseBar = FResponseBar;
//# sourceMappingURL=FresponseBar.js.map